import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Privacy Policy</h1>
      <p style={styles.updated}>Last updated: June 25, 2026</p>

      <section style={styles.section}>
        <h2 style={styles.heading}>1. Who We Are</h2>
        <p style={styles.paragraph}>
          Moa (moashops.com) is an individually operated proxy-purchase and goods resale service.
          This policy explains what personal information we collect and how we use it. For any
          privacy questions, contact us at support@moashops.com.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>2. Information We Collect</h2>
        <p style={styles.paragraph}>
          We collect only the information needed to provide our service:
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Account details: email address and name.</li>
          <li style={styles.listItem}>Order details: shipping address and contact number.</li>
          <li style={styles.listItem}>
            Payment is handled directly by our payment providers (PayPal and, where available,
            Stripe). We do not store your card numbers on our servers.
          </li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>3. How We Use Your Information</h2>
        <p style={styles.paragraph}>
          Your personal information is used solely for the purposes of providing our service —
          processing and shipping your orders, handling proxy-purchase requests, customer support,
          and meeting legal obligations. It will never be used for any purpose beyond these
          processing purposes, and it is never sold to third parties.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>4. Sharing With Service Providers</h2>
        <p style={styles.paragraph}>
          We share information only to the extent necessary to fulfill your order — for example with
          payment providers (PayPal, Stripe), our email delivery provider, and shipping/tracking
          services. These providers process the data only on our behalf to complete the service you
          requested.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>5. Data Retention</h2>
        <p style={styles.paragraph}>
          We keep your information for as long as your account is active or as needed to provide the
          service and comply with legal requirements. You may request deletion of your account and
          personal data at any time.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>6. Security</h2>
        <p style={styles.paragraph}>
          We take the security of your information seriously and give it our utmost care. Passwords
          are stored only in hashed form, access to personal data is restricted, and we work to
          protect your information against unauthorized access, alteration, or disclosure.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>7. Your Rights</h2>
        <p style={styles.paragraph}>
          You may access, correct, or request deletion of your personal information at any time by
          contacting us at support@moashops.com.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>8. Governing Law</h2>
        <p style={styles.paragraph}>
          This policy is governed by the laws of the Republic of Korea.
        </p>
      </section>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  page: { maxWidth: 800, margin: '60px auto', padding: '0 20px 120px' },
  title: { fontSize: 26, fontWeight: 700, color: '#333', marginBottom: 8 },
  updated: { fontSize: 13, color: '#aaa', marginBottom: 40, paddingBottom: 16, borderBottom: '2px solid #f0f0f0' },
  section: { marginBottom: 32 },
  heading: { fontSize: 17, fontWeight: 700, color: '#444', marginBottom: 12 },
  paragraph: { fontSize: 14, lineHeight: 1.8, color: '#555' },
  list: { margin: '12px 0 0', paddingLeft: 20 },
  listItem: { fontSize: 14, lineHeight: 1.8, color: '#555', marginBottom: 6 },
};

export default PrivacyPage;
